module.exports = __webpack_public_path__ + "media/map/marker-icon-2x-orange-a5fcf390.png";